import React, { Fragment, PureComponent } from 'react';
import { Field, reduxForm, change, getFormValues } from 'redux-form';
import PassengerBar from './passengerbar';
import { validate, renderSelectField, renderMaterialField, checkValidCountries, popularCountriesArr } from '../../../helpers/formHelper';
import { isoNameConvert } from '../../../helpers/locationHelper';
import { paxLogo, paxStatus } from '../../../helpers/passengerHelper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { POPULAR_COUNTRIES, FUSE_OPTIONS } from '../../../config';
import Fuse from 'fuse.js';
import _forEach from 'lodash/forEach';

const submit = (values) => {
    //console.log("DISPATCHED FROM CONFIRMATION - ", values);
}

class EmergencyPassenger extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      phoneDropdown:"",
      isPhoneOpen:false,
      phoneSearch:[],
      phoneSearchOriginal:[],
      phoneDropdownNumber:-1,
    }
    this.documentClickHandler = this.documentClickHandler.bind(this);
    this.documentKeydownHandler = this.documentKeydownHandler.bind(this);
    this.onDropdownClick = this.onDropdownClick.bind(this);
    this.onPhoneChange = this.onPhoneChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.fusePhone = null;

  }

  componentDidMount(){

    document.body.addEventListener('click', this.documentClickHandler);

    //Toggle material design active state
    _forEach(document.querySelectorAll('.emergency-item input'), item => {
      setTimeout(() => { if(item.value !== "") item.parentElement.parentElement.classList.add('hovered'); } ,180);
    });

    //Populate phone
    setTimeout(() => {
      if(this.props.nationality.length > 0){
        this.populatePaxDetails(this.props.emergencyPaxValues, this.props.nationality);
      }
    },300);

    //setup custom nationality flags
    this.setState({
      phoneSearch:this.props.nationality,
      phoneSearchOriginal:this.props.nationality,
    }, () => {
      this.fusePhone = new Fuse(this.props.nationality, FUSE_OPTIONS);
    });

  }

  populatePaxDetails(emergencyPaxValues, nationality){

    //Populate nationality/state if exist in state
    if(emergencyPaxValues && emergencyPaxValues.emergencyPrefix !== "") {
      if(window.innerWidth < 640){
        this.onSelectMobile("emergencyPrefix");
      }else{
        this.onPhoneChange(null, emergencyPaxValues.emergencyPrefix, isoNameConvert(emergencyPaxValues.emergencyPrefix, "phonePrefix", nationality, null));
      }
    }

  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
    this.fusePhone = null;
    this.setState({
      phoneSearch:[],
      phoneSearchOriginal:[],
    });
  }

  documentKeydownHandler(e){
    //Increment/Decrement dropdown cursor position
    const { isPhoneOpen, phoneDropdownNumber } = this.state;
    const phoneInput = document.querySelectorAll('.filterDropdown.basket ul.phone li');

    if(isPhoneOpen){
      if(e.key === 'ArrowDown' && phoneDropdownNumber < phoneInput.length - 1){
        this.setState({phoneDropdownNumber:phoneDropdownNumber + 1});
      }
      else if(e.key === 'ArrowUp' && phoneDropdownNumber > 0){
        this.setState({phoneDropdownNumber:phoneDropdownNumber - 1});
      }
      else if(e.key === 'Enter'){
        if(phoneInput[phoneDropdownNumber] !== undefined){
          this.onPhoneChange(null, phoneInput[phoneDropdownNumber].dataset.countrycode, phoneInput[phoneDropdownNumber].dataset.dialingcode, false);
        }
      }
    }

  }

  componentDidUpdate(prevProps, prevState){

    const { emergencyPaxValues, phoneDropdownNumber } = this.state;
    const { nationality } = this.props;

    if(window.innerWidth > 639){
      if(phoneDropdownNumber !== prevState.phoneDropdownNumber){
        const phoneInputContainer = document.querySelector('.filterDropdown.basket ul.phone');
        const phoneInput = document.querySelectorAll('.filterDropdown.basket ul.phone li');

        for(let i = 0; i < phoneInput.length; i++){
          phoneInput[i].classList.remove('hover');
        }

        if(phoneInput[phoneDropdownNumber].dataset.countrycode !== undefined){

          //hover state
          phoneInput[phoneDropdownNumber].classList.add('hover');

          //scroll container
          phoneInputContainer.scrollTop = phoneInput[phoneDropdownNumber].offsetTop;
        }
      }
    }


    //Populate nationality/state/phone
    if(nationality !== this.props.nationality){
      this.populatePaxDetails(emergencyPaxValues, nationality);
    }

  }

  documentClickHandler(e){
    const { phoneDropdown, phoneSearchOriginal, phoneSearch } = this.state;

    try{
      if(window.innerWidth > 639){
        if( e.target.offsetParent.className !== "filterDropdown basket no-margin" && e.target.offsetParent.className !== "phone"){
          this.setState({
            isPhoneOpen:false,
            phoneSearch:(phoneDropdown === "" || checkValidCountries(phoneSearchOriginal, phoneDropdown) ) ? phoneSearchOriginal : phoneSearch,
          }, () => {
            if(checkValidCountries(phoneSearchOriginal, phoneDropdown)){
            const dividers =  document.querySelectorAll('.dividers');
              for(let i = 0; i < dividers.length; i++){
                dividers[i].classList.remove('hide');
              }
            }
          });

        }
      }
    }catch(e){}

  }
  onDropdownClick(e, dropName){
    e.preventDefault();
    switch (dropName) {
      case 'phone':
        this.setState({ isPhoneOpen:!this.state.isPhoneOpen });
        break;
      default:
    }
  }
  onPhoneChange(e, name, dialCode, isClose=false){
    if(name !== undefined){
      this.setState({phoneDropdown:dialCode, isPhoneOpen:isClose}, () => { this.props.change('emergencyPrefix', name) });
    }
  }
  onInputChange(e, inputName){
    const dividers = document.querySelectorAll('.dividers');

    if(e.target.value === ""){

      for(let i = 0; i < dividers.length; i++){
        dividers[i].classList.remove('hide');
      }
      switch (inputName) {
        case 'phone':
            this.setState({phoneDropdown:"", phoneSearch:this.state.phoneSearchOriginal});
          break;
        default:
      }

    }else{

      for(let i = 0; i < dividers.length; i++){
        dividers[i].classList.add('hide');
      }
      switch (inputName) {
        case 'phone':
          this.setState({phoneDropdown:e.target.value, phoneSearch:this.fusePhone.search(e.target.value)});
        break;
        default:
      }

    }

  }

  onSelectMobile(selectName){
    switch (selectName) {
      case 'emergencyPrefix':
        document.querySelector('.payment-select select[name="emergencyPrefix"]').classList.add('active');
        break;
      default:
    }
  }

  renderPrefixSelectMobile(){
    return(
    <Field name="emergencyPrefix" component={renderSelectField} classType="payment-select" label="" onChange={e => this.onSelectMobile('emergencyPrefix')}>
      <option value="" disabled>Dial Code</option>
      <option value="" disabled>----------</option>
        { popularCountriesArr(this.state.phoneSearch, POPULAR_COUNTRIES).map(item => <option key={item.dialing_code + Math.random()} value={ item.iso_country_code } disabled={item.dialing_code !== "" ? "" : 'disabled' }>{(item.dialing_code !== "") ? `${item.name} ( ${item.dialing_code} )` : "----------------"}</option>)}
      <option value="" disabled>----------</option>
      {this.props.nationality.map(item => <option key={item.dialing_code + Math.random()} value={ item.iso_country_code }  disabled={item.dialing_code !== "" ? "" : 'disabled' }>{(item.dialing_code !== "") ? `${item.name} ( ${item.dialing_code} )` : "----------------"} </option>)}
    </Field>
    )
  }
  renderPrefixSelect(){

    const { isPhoneOpen, phoneDropdown, phoneSearch } = this.state;

    return(
      <div className="filterDropdown basket no-margin">
        <div className="row">
          <div className="columns small-12 no-margin">
            <div className="columns small-12 no-margin no-padding">
              <input type="text" placeholder="Dial code" onClick={ e => this.onDropdownClick(e, 'phone') } onKeyDown={e => this.documentKeydownHandler(e)} onChange={ e => this.onInputChange(e,'phone') } value={phoneDropdown} className={`filterDropdown-btn phone ${isPhoneOpen ? 'active' : ''} `} />
              <i className={`fa fa-chevron-down phone ${isPhoneOpen ? 'active' : ''}`} aria-hidden="true"></i>
            </div>
          </div>
           <div className="columns small-12 no-margin phone-container">
            <ul className="phone" style={{display: isPhoneOpen ? 'block':'none' }} >
              <li className="dividers" data-index="0">--------------------</li>
              {
                popularCountriesArr(phoneSearch, POPULAR_COUNTRIES).map((item, index) => {
                  return (
                    <li
                      data-index={index + 1}
                      data-countrycode={item.iso_country_code}
                      data-dialingcode={item.dialing_code}
                      onClick={e => this.onPhoneChange(e, item.iso_country_code, item.dialing_code)}
                      key={item.dialing_code + Math.random()}>
                      <img alt={`${item.name} flag`} src={`/images/flags/${item.iso_country_code.toLowerCase()}.png` } /> {item.name} ( {item.dialing_code} )
                    </li>
                  )
                })
              }
              <li className="dividers" data-index={POPULAR_COUNTRIES.length + 1}>--------------------</li>
              {

                  phoneSearch.map((item, index) => {
                    return (
                      <li
                        data-index={(POPULAR_COUNTRIES.length + 2) + index}
                        data-countrycode={item.iso_country_code}
                        data-dialingcode={item.dialing_code}
                        onClick={e => this.onPhoneChange(e, item.iso_country_code, item.dialing_code)}
                        key={item.dialing_code + Math.random()}>
                        <img alt={`${item.name} flag`} src={`/images/flags/${item.iso_country_code.toLowerCase()}.png` } />  {item.name} ( {item.dialing_code} )
                      </li>
                    )
                  })

              }
            </ul>
          </div>
        </div>
        <span className="form-error">Your dial code is required</span>
      </div>
    )
  }



  render(){
    const { handleSubmit, emergencyform } = this.props;
    const emergencyData = Object.keys(emergencyform).length > 0 ? emergencyform : "";

    return (
        <Fragment>
          <PassengerBar title="Emergency contact" status={paxStatus(emergencyData)} barClass="emergency" icon={paxLogo(emergencyData)}/>


          <div className="confirm-modal-wrapper border-bottom">
            <p className="bold emergency-text">In the event of an emergency please provide contact details of a person who is NOT travelling with you.</p>

            <form className="emergency-item" onSubmit={handleSubmit}>
              <div className="row">

                <div className="column small-12 medium-6 col-left-mod">
                  <Field name="firstName" fieldId="firstName" component={renderMaterialField} type="text" label="First Name *" />
                </div>

               <div className="column small-12 medium-6 col-right-mod">
                  <Field name="surname" fieldId="surname" component={renderMaterialField} type="text" label="Surname *" />
                </div>

             </div>
             <div className="row">
               <div className="column small-12 medium-6 col-left-mod">
                 <div className="column small-4 no-padding">
                     {  (window.innerWidth < 640) ? this.renderPrefixSelectMobile() : this.renderPrefixSelect()  }
                 </div>
                 <div className="column small-8 no-padding">
                   <Field name="emergency" fieldId="emergency" component={renderMaterialField} type="text" label="Phone number" />
                 </div>
               </div>
             </div>
            </form>
          </div>
        </Fragment>
      )
    }

}


EmergencyPassenger = reduxForm({
  form: 'EmergencyPassenger',
  validate,
  onSubmit:submit,
  destroyOnUnmount: false
})(EmergencyPassenger);

function mapStateToProps(state){
  return{
    emergencyform:state.form.EmergencyPassenger,
    emergencyPaxValues: getFormValues('EmergencyPassenger')(state)
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    change
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EmergencyPassenger);



// WEBPACK FOOTER //
// ./src/components/confirmation/components/emergencypassenger.js